import React from "react";

export type TabKey = "reservations" | "subscriptions" | "load" | "settings";

const tabs: { key: TabKey; label: string }[] = [
    {key: "reservations", label: "Заявки"},
    {key: "load", label: "Загрузка"},
    {key: "subscriptions", label: "Абонементы"},
    {key: "settings", label: "Настройки"}
];

interface Props {
    active: TabKey;
    onChange: (key: TabKey) => void;
}

export const NavTabs: React.FC<Props> = ({active, onChange}) => {
    return (
        <nav className="mt-2 rounded-2xl border border-slate-800 bg-slate-900/70 p-1 flex">
            {tabs.map((tab) => {
                const isActive = tab.key === active;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        onClick={() => onChange(tab.key)}
                        className={[
                            "flex-1 rounded-xl px-3 py-1.5 text-xs font-medium transition-all",
                            isActive
                                ? "bg-sky-500 text-white shadow-sm"
                                : "text-slate-400 hover:text-slate-100 hover:bg-slate-800"
                        ].join(" ")}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </nav>
    );
};
